import { Routes } from '@angular/router';
import { GlobalComponent } from './features/global/global.component';
import { EvaluationComponent } from './features/evaluation/evaluation.component';
import { EnseignesComponent } from './features/enseignes/enseignes.component';
import { NexpeComponent } from './features/nexpe/nexpe.component';
import { NouveautesComponent } from './features/nouveautes/nouveautes.component';
import { UtilisateursComponent } from './features/utilisateurs/utilisateurs.component';
import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'global',
    pathMatch: 'full',
  },
  {
    path: 'global',
    component: GlobalComponent,
    canActivate: [authGuard],
  },
  {
    path: 'evaluation',
    component: EvaluationComponent,
    canActivate: [authGuard],
  },
  {
    path: 'enseignes',
    component: EnseignesComponent,
    canActivate: [authGuard],
  },
  {
    path: 'nexpe',
    component: NexpeComponent,
    canActivate: [authGuard],
  },
  {
    path: 'nouveautes',
    component: NouveautesComponent,
    canActivate: [authGuard],
  },
  {
    path: 'utilisateurs',
    component: UtilisateursComponent,
    canActivate: [authGuard],
  },
];
